import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import { Helmet } from 'react-helmet';

@withNamespaces()
@inject('store')
@observer
class FamilyBlockedPage extends Component {
    componentDidMount() {
        const { store } = this.props;
        store.app.setPageTitle('FAMILY.MANAGE.PAGE_TITLE');
    }

    render() {
        const { t } = this.props;

        return (
            <Fragment>
                <Helmet>
                    <title>{t('FAMILY.MANAGE.PAGE_TITLE')}</title>
                </Helmet>

                <div className="container container-fixed-lg mt-3">
                    <div className="card">
                        <div className="card-body">
                            Hey, you don't have a family subscription yet!
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default FamilyBlockedPage;


// WEBPACK FOOTER //
// ./src/modules/family/pages/blocked/family-blocked-page.js